namespace Teva {
    export class Resources {
        static CurrentCulture;

        static GetString(Category, Name): string {
            try {
                return Resources.LocalizedStrings[Resources.CurrentCulture][Category][Name];
            }
            catch (e) {
                console.log("String not found: " + Category + ", " + Name);
                return Name;
            }
        }

        static LocalizedStrings =
        {
            "he": {
                SelectBox: {
                    Searching: "מחפש...",
                    NoResultsFound: "לא נמצאו תוצאות",
                    TextTooShort: "הטקסט קצר מדי"
                }
            },

            "en": {
                SelectBox: {
                    Searching: "Searching...",
                    NoResultsFound: "No results found",
                    TextTooShort: "Text too short"
                }
            },

            "ar": {
                SelectBox: {
                    Searching: "يبحث...",
                    NoResultsFound: "لم يتم العثور على نتائج",
                    TextTooShort: "النص قصير جدا"
                }
            },
        };
    }
}
